import * as React from 'react';
export const allySvg = React.forwardRef(function allySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#650360',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M24.22 15.52c0-1.26-.03-1.93-.47-3.04a8.75 8.75 0 0 0-8.14-5.56 9.36 9.36 0 0 0-9.56 9.56c0 4.99 4.33 8.45 8.6 8.55l3.51-5.79.86-.21v6.05h5.2v-9.56zm-8.65 4.37c-2.4 0-5.1-4.06-2.4-6.7 2.4-2.36 5.86-.9 5.86 2.38v3.46l-3.46.86z',
      }),
    ),
  );
});
allySvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var ally = {
  category: 'brand',
  colorable: false,
  name: 'ally',
  svg: allySvg,
};
